import { createContext, useContext } from "react";
import type * as Y from "yjs";
import type { Awareness } from "y-protocols/awareness";
import type { Participant } from "@worktools/shared";
import type { BoardMeta } from "../api/client";

export type BoardContextValue = {
  doc: Y.Doc;
  awareness: Awareness;
  board: BoardMeta;
  me: Participant;
  connected: boolean;
};

export const BoardContext = createContext<BoardContextValue | null>(null);

export function useBoard(): BoardContextValue {
  const value = useContext(BoardContext);
  if (!value) throw new Error("useBoard must be used inside a BoardContext");
  return value;
}
